"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentAnimationDurationVfxTimeInterval = exports.CurrentAnimationDurationVfxTimeInterval = exports.AbilityAnimationVfxTimeInterval = exports.MillisecondVfxTimeInterval = void 0;
class MillisecondVfxTimeInterval {
    constructor(milliseconds) {
        this.milliseconds = milliseconds;
        this.__typeName = "Millisecond";
    }
}
exports.MillisecondVfxTimeInterval = MillisecondVfxTimeInterval;
MillisecondVfxTimeInterval.OneHundred = new MillisecondVfxTimeInterval(100);
class AbilityAnimationVfxTimeInterval {
    constructor(actorId, abilityType, fallbackKey) {
        this.actorId = actorId;
        this.abilityType = abilityType;
        this.fallbackKey = fallbackKey;
        this.__typeName = "AbilityAnimation";
    }
}
exports.AbilityAnimationVfxTimeInterval = AbilityAnimationVfxTimeInterval;
/**
 * @deprecated Use AbilityAnimationVfxTimeInterval instead.
 */
class CurrentAnimationDurationVfxTimeInterval {
    constructor(actorId, fallbackPercentage = .5) {
        this.actorId = actorId;
        this.fallbackPercentage = fallbackPercentage;
        this.__typeName = "CurrentAnimationDuration";
    }
}
exports.CurrentAnimationDurationVfxTimeInterval = CurrentAnimationDurationVfxTimeInterval;
class PercentAnimationDurationVfxTimeInterval {
    constructor(actorId, percentCompleted = .5) {
        this.actorId = actorId;
        this.percentCompleted = percentCompleted;
        this.__typeName = "PercentAnimationDuration";
    }
}
exports.PercentAnimationDurationVfxTimeInterval = PercentAnimationDurationVfxTimeInterval;
